import { useEffect } from "react";

/**
 * Per-page SEO without extra dependencies: sets <title>, description, canonical, Open Graph / Twitter
 * tags and (optionally) JSON-LD structured data. It edits the tags already present in public/index.html,
 * so there are never duplicates, and restores nothing on unmount (the next page sets its own).
 */
export const SITE = "https://www.navicareservices.in";

function setMeta(attr, key, value) {
  if (value == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
}
function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", keywords, noindex = false, jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const url = `${SITE}${path === "/" ? "/" : path}`;
    if (title) { document.title = title; setMeta("property", "og:title", title); setMeta("name", "twitter:title", title); }
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); setMeta("name", "twitter:description", description); }
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("property", "og:url", url);
    setLink("canonical", url);
    let script;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json"; script.dataset.seo = "page"; script.text = ld;
      document.head.appendChild(script);
    }
    return () => { if (script && script.parentNode) script.parentNode.removeChild(script); };
  }, [title, description, path, keywords, noindex, ld]);
  return null;
}
